import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroBeniDiTerziModalComponent } from './worker-registro-beni-di-terzi-modal';

export const WorkerRegistroBeniDiTerziModalModule: string = ng
    .module('worker-registro-beni-di-terzi-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroBeniDiTerziModalComponent', WorkerRegistroBeniDiTerziModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-beni-di-terzi-modal/worker-registro-beni-di-terzi-modal.module.ts